
<template>
  
  <div v-if="condicion_de_rutas" class="w-full footer px-5 pb-7 md:pb-5 md:pt-10 pt-32 relative">
    <div class="w-full -translate-y-14">
      <Newsletter />
    </div>
    <div class="max-w-[1300px] md:mx-auto mx-[20px] text-white">
      <div class="grid gap-5 md:gap-10 mb-5 md:my-10 footer-container md:px-3">
        <div class="flex flex-col gap-5">
          <img src="/img/newhome/footer/grupo-leon.webp" class="max-w-[150px] -translate-y-2" />
          <p class="text-sm">Construyendo confianza, innovación y futuro, de la mano de las personas que dan vida a
            nuestra organización.</p>
          <div class="flex flex-row gap-5">
            <NuxtLink href="https://web.facebook.com/leonautomotriz/?_rdc=1&_rdr" target="_blank"><img
                src="/img/newhome/footer/facebook.webp" alt="facebook"
                class="w-[50px] hover:scale-105 transition-all duration-500 social-icon" /></NuxtLink>
            <NuxtLink href="https://www.instagram.com/leonservicioautomotriz/" target="_blank"><img
                src="/img/newhome/footer/instagram.webp" alt="instagram"
                class="w-[50px] hover:scale-105 transition-all duration-500 social-icon" /></NuxtLink>
            <NuxtLink href="https://www.linkedin.com/company/leon-servicio-automotriz/" target="_blank"><img
                src="/img/newhome/footer/linkedin.webp" alt="linkedin"
                class="w-[50px] hover:scale-105 transition-all duration-500 social-icon" /></NuxtLink>
            <NuxtLink href="https://www.youtube.com/@leonservicioautomotriz" target="_blank"><img
                src="/img/newhome/footer/youtube.webp" alt="youtube"
                class="w-[50px] hover:scale-105 transition-all duration-500 social-icon" /></NuxtLink>
            <NuxtLink href="https://www.tiktok.com/@leonservicioautomotriz" target="_blank"><img
                src="/img/newhome/footer/tiktok.webp" alt="tiktok"
                class="w-[50px] hover:scale-105 transition-all social-icon" /></NuxtLink>
            <NuxtLink href="https://www.threads.net/@leonservicioautomotriz" target="_blank"><img
                src="/img/newhome/footer/threads.webp" alt="threads"
                class="w-[50px] hover:scale-105 transition-all duration-500 social-icon" /></NuxtLink>
          </div>
        </div>
        <div>
          <div class="flex flex-row items-center gap-3" @click="toggleMenu('servicios')">
            <span v-if="isMobile"
              class="w-5 h-5 flex items-center justify-center rounded-full border-2 border-white text-white font-bold text-xl'">
              {{ openMenus.servicios ? '-' : '+' }} </span>
            <p class="text-base font-bold uppercase">SERVICIOS</p>
          </div>
          <ul class="flex flex-col gap-5 mt-4 text-sm transition-all duration-300 overflow-hidden [&>li>a]:transition"
            :class="{
              'max-h-0': !openMenus.servicios && isMobile,
              'max-h-[260px] my-5': openMenus.servicios,
            }">
            <li class="hover:text-ROJO_LEON">
              <NuxtLink :to="`/${NEGOCIOS.NEUMATICOS}`">Neumáticos</NuxtLink>
            </li>
            <li class="hover:text-ROJO_LEON">
              <NuxtLink :to="`/${NEGOCIOS.FRENOS}`">Frenos</NuxtLink>
            </li>
            <li class="hover:text-ROJO_LEON">
              <NuxtLink :to="`/${NEGOCIOS.FLUIDOS}`">Fluidos</NuxtLink>
            </li>
            <li class="hover:text-ROJO_LEON">
              <NuxtLink :to="`/${NEGOCIOS.BATERIAS}`">Baterías</NuxtLink>
            </li>
            <li class="hover:text-ROJO_LEON">
              <NuxtLink :to="`/${NEGOCIOS.TRENDELANTERO}`">Tren delantero</NuxtLink>
            </li>
            <li class="hover:text-ROJO_LEON">
              <NuxtLink :to="`/${NEGOCIOS.AMORTIGUADORES}`">Amortiguadores</NuxtLink>
            </li>
          </ul>
        </div>
        <div>
          <div class="flex flex-row items-center gap-3" @click="toggleMenu('conocenos')">
            <span v-if="isMobile"
              class="w-5 h-5 flex items-center justify-center rounded-full border-2 border-white text-white font-bold text-xl'">
              {{ openMenus.conocenos ? '-' : '+' }} </span>
            <p class="text-base font-bold uppercase">CONÓCENOS</p>
          </div>
          <ul class="flex flex-col gap-5 mt-4 text-sm transition-all duration-300 overflow-hidden [&>li>a]:transition"
            :class="{
              'max-h-0': !openMenus.conocenos && isMobile,
              'max-h-[200px] my-5': openMenus.conocenos,
            }">
            <li class="hover:text-ROJO_LEON">
              <NuxtLink href="/quienes-somos">Quiénes Somos</NuxtLink>
            </li>
            <li class="hover:text-ROJO_LEON">
              <NuxtLink href="/nuestros-locales">Locales</NuxtLink>
            </li>
            <li class="hover:text-ROJO_LEON">
              <NuxtLink href="/revision-tecnica">Calendario Revisión Técnica</NuxtLink>
            </li>
            <li class="hover:text-ROJO_LEON">
              <NuxtLink href="https://qr.queop.com/a4391284c0d2cbbe4c17f70526c4dc0d1">Sugerencias y Reclamos</NuxtLink>
            </li>
            <li class="hover:text-ROJO_LEON">
              <NuxtLink to="/postulaciones">Trabaja con nosotros</NuxtLink>
            </li>
            <li class="hover:text-ROJO_LEON">
              <NuxtLink href="/blog">Blog</NuxtLink>
            </li>
          </ul>
        </div>
        <div>
          <div class="flex flex-row items-center gap-3" @click="toggleMenu('transparencia')">
            <span v-if="isMobile"
              class="w-5 h-5 flex items-center justify-center rounded-full border-2 border-white text-white font-bold text-xl'">
              {{ openMenus.transparencia ? '-' : '+' }} </span>
            <p class="text-base font-bold uppercase">transparencia</p>
          </div>
          <ul class="flex flex-col gap-5 mt-4 text-sm transition-all duration-300 overflow-hidden [&>li>a]:transition"
            :class="{
              'max-h-0': !openMenus.transparencia && isMobile,
              'max-h-[200px] my-5': openMenus.transparencia,
            }">
            <li class="hover:text-ROJO_LEON">
              <NuxtLink href="/concursos-promociones">Concursos y Promociones</NuxtLink>
            </li>
            <li class="hover:text-ROJO_LEON">
              <NuxtLink href="/boletas">Consulta de Boletas</NuxtLink>
            </li>
            <li class="hover:text-ROJO_LEON">
              <NuxtLink to="/seguridad-y-privacidad">Seguridad y Privacidad</NuxtLink>
            </li>
            <li class="hover:text-ROJO_LEON">
              <NuxtLink to="/terminos-y-condiciones">Términos y Condiciones</NuxtLink>
            </li>
          </ul>
        </div>
        <!--<div class="flex flex-col gap-5">
          <p class="text-base font-bold uppercase">Somos parte</p>
          <img src="/img/newhome/footer/ccs-logo.webp" alt="confianza-ecomerce" class="self-start" />
        </div>-->
        <div class="flex flex-col gap-5">
          <p class="text-base font-bold uppercase">Medios de pago</p>
          <img src="/img/newhome/footer/webpay.webp" alt="webpay" class="self-start" />
          <div class="grid grid-cols-5">
            <img src="/img/newhome/footer/visa.webp" alt="visa" class="w-full" />
            <img src="/img/newhome/footer/mastercard.webp" alt="mastercard" class="w-full" />
            <img src="/img/newhome/footer/american-express.webp" alt="american-express" class="w-full" />
            <img src="/img/newhome/footer/dinners-club.webp" alt="dinners-club" class="w-full" />
            <img src="/img/newhome/footer/crm.webp" alt="crm-fallabela" class="w-full" />
          </div>
        </div>
      </div>
      <hr class="bg-white" />
      <p class="text-center my-5">Todos los derechos reservados© LEÓN Servicio Automotriz {{ currentYear }}</p>
    </div>
  </div>

</template>

<script setup>
import { reactive, ref, computed } from 'vue';
import Newsletter from "~/components/newhome/newsletter/Newsletter.vue";
import { NEGOCIOS } from "~/constants/negocios";

const modo_sistema = useState('modo_sistema');
const route = useRoute()
const router = useRouter()

const condicion_de_rutas = computed(() => {
  const esLocal = NEGOCIOS.LOCALES.includes(modo_sistema.value);
  const esRutaValida = modo_sistema.value === NEGOCIOS.HOME || 
    route.path === `/${NEGOCIOS.NEUMATICOS}`      || 
    route.path === `/${NEGOCIOS.ACEITES}`         ||
    route.path === `/${NEGOCIOS.BATERIAS}`        ||     
    route.path === `/${NEGOCIOS.FRENOS}`          || 
    route.path === `/${NEGOCIOS.AFINAMIENTO}`     || 
    route.path === `/${NEGOCIOS.AMORTIGUADORES}`  || 
    route.path === `/${NEGOCIOS.TRENDELANTERO}`   || 
    route.path === `/${NEGOCIOS.ALINEACION}`      || 
    route.path === `/${NEGOCIOS.BALANCEO}`        || 
    route.path === `/${NEGOCIOS.GEOMETRIA}`       || 
    route.path === `/${NEGOCIOS.KILOMETRAJE}`     || 
    route.path === `/${NEGOCIOS.HIGIENIZACION}`   || 
    route.path === `/${NEGOCIOS.FLUIDOS}`         || 
    route.path === `/${NEGOCIOS.ELECTRICO}`       || 
    route.path === `/${NEGOCIOS.ACCESORIOS}`              ||
    route.path === `/${NEGOCIOS.REVISIONTECNICA}`         ||
    route.path === `/${NEGOCIOS.NEUMATICOS}/more`         ||
    route.path === `/${NEGOCIOS.NEUMATICOS}/guide`        ||
    route.path === `/${NEGOCIOS.NEUMATICOS}/tips`         ||
    route.path === `/${NEGOCIOS.NEUMATICOS}/detail`       ||
    route.path === `/${NEGOCIOS.NEUMATICOS}/signal`       ||
    route.path === `/${NEGOCIOS.BATERIAS}/change`         ||
    route.path === `/${NEGOCIOS.BATERIAS}/type`           ||
    route.path === `/${NEGOCIOS.BATERIAS}/concepts`       ||
    route.path === `/${NEGOCIOS.BATERIAS}/mantenimiento`  ||
    route.path === `/boletas` ||
    esLocal

  return esRutaValida
})

const isMobile = ref(false)
const openMenus = reactive({
  servicios: false,
  conocenos: false,
  transparencia: false,
});

const currentYear = computed(() => new Date().getFullYear());

onMounted(() => {
  isMobile.value = window.innerWidth <= 768;
})

const toggleMenu = (menu) => {
  if (window.innerWidth > 768) return;
  openMenus[menu] = !openMenus[menu];
};
</script>

<style scoped>
.footer {
  background: url('/img/newhome/footer/bg-footer.webp');
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}

.footer-container {
  grid-template-columns: 1.5fr repeat(4, 1fr);
}

@media screen and (max-width: 768px) {
  .footer-container {
    grid-template-columns: 1fr;
  }
}

.footer .social-icon {
  filter: brightness(0) invert(1);
}

.footer .social-icon:hover {
  filter: brightness(0) saturate(100%) invert(22%) sepia(100%) saturate(5000%) hue-rotate(0deg) brightness(60%);

}
</style>